export const CHAT_CREATE_REQUEST = 'CHAT_CREATE_REQUEST';
export const CHAT_CREATE_SUCCESS = 'CHAT_CREATE_SUCCESS';
export const CHAT_CREATE_FAIL = 'CHAT_CREATE_FAIL';
export const CHAT_CREATE_RESET = 'CHAT_CREATE_RESET';

export const CHAT_LIST_REQUEST = "CHAT_LIST_REQUEST";
export const CHAT_LIST_SUCCESS = "CHAT_LIST_SUCCESS";
export const CHAT_LIST_FAIL = "CHAT_LIST_FAIL";
export const CHAT_LIST_UPDATE = "CHAT_LIST_UPDATE";

export const CHAT_LIST_ADD = "CHAT_LIST_ADD";

export const CHAT_HISTORY_REQUEST = "CHAT_HISTORY_REQUEST";
export const CHAT_HISTORY_SUCCESS = "CHAT_HISTORY_SUCCESS";
export const CHAT_HISTORY_FAIL = "CHAT_HISTORY_FAIL";

export const CHAT_OLDER_MESSAGES_REQUEST = "CHAT_OLDER_MESSAGES_REQUEST";
export const CHAT_OLDER_MESSAGES_SUCCESS = "CHAT_OLDER_MESSAGES_SUCCESS";
export const CHAT_OLDER_MESSAGES_FAIL = "CHAT_OLDER_MESSAGES_FAIL";

export const MESSAGE_RECEIVED = "MESSAGE_RECEIVED";

export const MESSAGE_SEEN = "MESSAGE_SEEN";

export const SET_ACTIVE_CHAT = "SET_ACTIVE_CHAT";

export const CHAT_UNREAD_UPDATE = "CHAT_UNREAD_UPDATE";

export const USER_TYPING = "USER_TYPING";
export const USER_STOPPED_TYPING = "USER_STOPPED_TYPING";

export const MESSAGE_EDIT = "MESSAGE_EDIT";
export const MESSAGE_DELETE = "MESSAGE_DELETE";
export const CHAT_LAST_MESSAGE_UPDATE = "CHAT_LAST_MESSAGE_UPDATE";
export const CHAT_UPDATE = "CHAT_UPDATE";

export const CHAT_UPDATE_DATA_REQUEST = 'CHAT_UPDATE_DATA_REQUEST';
export const CHAT_UPDATE_DATA_SUCCESS = 'CHAT_UPDATE_DATA_SUCCESS';
export const CHAT_UPDATE_DATA_FAIL = 'CHAT_UPDATE_DATA_FAIL';

export const CHAT_UPDATE_ROLE_REQUEST = 'CHAT_UPDATE_ROLE_REQUEST';
export const CHAT_UPDATE_ROLE_SUCCESS = 'CHAT_UPDATE_ROLE_SUCCESS';
export const CHAT_UPDATE_ROLE_FAIL = 'CHAT_UPDATE_ROLE_FAIL';

export const CHAT_TRANSFER_OWNERSHIP_REQUEST = 'CHAT_TRANSFER_OWNERSHIP_REQUEST';
export const CHAT_TRANSFER_OWNERSHIP_SUCCESS = 'CHAT_TRANSFER_OWNERSHIP_SUCCESS';
export const CHAT_TRANSFER_OWNERSHIP_FAIL = 'CHAT_TRANSFER_OWNERSHIP_FAIL';

export const CHAT_ADD_MEMBER_REQUEST = 'CHAT_ADD_MEMBER_REQUEST';
export const CHAT_ADD_MEMBER_SUCCESS = 'CHAT_ADD_MEMBER_SUCCESS';
export const CHAT_ADD_MEMBER_FAIL = 'CHAT_ADD_MEMBER_FAIL';

export const CHAT_REMOVE_MEMBER_REQUEST = 'CHAT_REMOVE_MEMBER_REQUEST';
export const CHAT_REMOVE_MEMBER_SUCCESS = 'CHAT_REMOVE_MEMBER_SUCCESS';
export const CHAT_REMOVE_MEMBER_FAIL = 'CHAT_REMOVE_MEMBER_FAIL';

export const CHAT_LEAVE_REQUEST = 'CHAT_LEAVE_REQUEST';
export const CHAT_LEAVE_SUCCESS = 'CHAT_LEAVE_SUCCESS';
export const CHAT_LEAVE_FAIL = 'CHAT_LEAVE_FAIL';

export const CHAT_MEMBERS_UPDATE = 'CHAT_MEMBERS_UPDATE';

export const CHAT_REMOVE = 'CHAT_REMOVE';